import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LoginAsStudent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get("access");
    const refresh = params.get("refresh");

    if (access && refresh) {
     
      localStorage.setItem("accessToken", access);
      localStorage.setItem("refreshToken", refresh);

      navigate("/");
    } else {
      
      navigate("/login");
    }
  }, [location, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <h5>در حال ورود به حساب دانش‌آموز...</h5>
    </div>
  );
};

export default LoginAsStudent;
